var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.82766 11.3105C7.02075 10.9271 7.12941 10.4944 7.12941 10.0364C7.12941 9.57832 7.02075 9.14564 6.82766 8.76223M6.82766 11.3105C6.35754 12.244 5.38694 12.8848 4.26588 12.8848C2.6844 12.8848 1.40234 11.6096 1.40234 10.0364C1.40234 8.46314 2.6844 7.18788 4.26588 7.18788C5.38694 7.18788 6.35754 7.82871 6.82766 8.76223M6.82766 11.3105L13.1582 14.4592M6.82766 8.76223L13.1582 5.61355M13.1582 14.4592C12.9651 14.8426 12.8565 15.2753 12.8565 15.7333C12.8565 17.3065 14.1385 18.5818 15.72 18.5818C17.3015 18.5818 18.5836 17.3065 18.5836 15.7333C18.5836 14.1601 17.3015 12.8848 15.72 12.8848C14.5989 12.8848 13.6284 13.5257 13.1582 14.4592ZM13.1582 5.61355C13.6284 6.54704 14.5989 7.18788 15.72 7.18788C17.3015 7.18788 18.5836 5.91256 18.5836 4.33939C18.5836 2.76622 17.3015 1.49091 15.72 1.49091C14.1385 1.49091 12.8565 2.76622 12.8565 4.33939C12.8565 4.7974 12.9651 5.23016 13.1582 5.61355Z",
    stroke: "#308EC3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.060d6769c3dbb364296466966a721766.svg";
export { ForwardRef as ReactComponent };